import * as svg from "../../../assets/comment-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CommentIcon = iconBuilder(svg, "CommentIcon", "0 0 16 16");
